import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// for testing, use StripePayment-fortesting.jsx instead of StripePayment.jsx
import StripePayment from "./Stripe/StripePayment";
import bg from "./Assets/Xianhe New Assets/balanceinspace-p1/bg-balanceinspace.png";
import check from "./Assets/Xianhe New Assets/balanceinspace-p1/check.png";
import directexpertaccess from "./Assets/Xianhe New Assets/balanceinspace-p1/directexpertaccess.png";
import fasterbetterdecisions from "./Assets/Xianhe New Assets/balanceinspace-p1/fasterbetterdecisions.png";
import onestopsolution from "./Assets/Xianhe New Assets/balanceinspace-p1/onestopsolution.png";
import onetrustedteam from "./Assets/Xianhe New Assets/balanceinspace-p1/onetrustedteam.png";
import flair from "./Assets/Xianhe New Assets/balanceinspace-p1/flair.png";

import butterfly from "./Assets/Xianhe New Assets/balanceinspace-p2/butterfly.png";
import compassanalysis from "./Assets/Xianhe New Assets/balanceinspace-p2/compassanalysis.png";
import enhancementsuggestions from "./Assets/Xianhe New Assets/balanceinspace-p2/enhancementsuggestions.png";
import fengshuirecommendations from "./Assets/Xianhe New Assets/balanceinspace-p2/fengshuirecommendations2.jpeg";

import step1 from "./Assets/Xianhe New Assets/balanceinspace-p3/step1.png";
import step2 from "./Assets/Xianhe New Assets/balanceinspace-p3/step2.png";
import step3 from "./Assets/Xianhe New Assets/balanceinspace-p3/step3.png";
import step4 from "./Assets/Xianhe New Assets/balanceinspace-p3/step4.png";
import consultationpreference from "./Assets/Xianhe New Assets/balanceinspace-p3/consultationpreference.png";
import familyinformation from "./Assets/Xianhe New Assets/balanceinspace-p3/familyinformation.png";
import homeinformation from "./Assets/Xianhe New Assets/balanceinspace-p3/homeinformation.png";
import butterflywithtext from "./Assets/Xianhe New Assets/balanceinspace-p3/butterflywithtext.png";
const gold = "#deaf77";
const goldSoft = "#C9A84B";
const purple = "#5b4b9a";

// 1 USD = 10 Gems, matching the rate used across Cart/Shop for gem checkout.
const EXCHANGE_RATE = 10;
const getGemAmount = (svc) =>
  svc?.gemAmt > 0 ? svc.gemAmt : Math.round((svc?.price || 0) * EXCHANGE_RATE);

const RECEIVE_STEPS = [
  {
    key: "compass",
    title: "COMPASS ANALYSIS",
    mockup: "compass",
  },
  {
    key: "recommendations",
    title: "YOUR SPACE RECOMMENDATIONS",
    mockup: "recommendations",
  },
  {
    key: "enhancements",
    title: "ENHANCEMENT SUGGESTIONS",
    mockup: "enhancements",
  },
];

// {
//     key: "submit",
//     label: "STEP 1",
//     title: "Submit Information",
//     desc: "Upload floor plan and complete the questionnaire.",
//     icon: "upload",
//     active: true,
//   },

const HOW_IT_WORKS_STEPS = [
  {
    key: "submit",
    label: "STEP 1",
    title: "Submit Payment",
    desc: "Complete the payment and the masters will be notified to start your review.",
    icon: "upload",
    active: true,
  },
  {
    key: "review",
    label: "STEP 2",
    title: "Master Review",
    desc: "Our Master conducts a detailed Feng Shui analysis.",
    icon: "review",
    active: false,
  },
  {
    key: "report",
    label: "STEP 3",
    title: "Receive Report",
    desc: "Receive your PDF report via email in 7-14 working days.",
    icon: "report",
    active: false,
  },
  // {
  //   key: "consultation",
  //   label: "STEP 4",
  //   title: "Consultation",
  //   desc: "Video consultation with Master for personalised guidance.",
  //   icon: "consultation",
  //   active: false,
  // },
];

const INFO_REQUIRED = [
  {
    key: "home",
    title: "HOME INFORMATION",
    icon: "camera",
    items: ["Property Address", "Unit Type", "Floor Plan", "Compass Direction"],
  },
  {
    key: "family",
    title: "FAMILY INFORMATION",
    icon: "magnifier",
    items: ["Household Members", "Bazi Information", "Altar (Yes / No)", "Living Arrangement"],
  },
  // {
  //   key: "preference",
  //   title: "CONSULTATION PREFERENCE",
  //   icon: "gear",
  //   items: ["Weekday/Weekend", "Morning/Afternoon", "Evening", "Preferred Time"],
  // },
];

const WHY_CHOOSE_US = [
  {
    key: "team",
    label: "One Trusted Team",
    icon: onetrustedteam,
  },
  {
    key: "expert",
    label: "Direct Expert Access",
    icon: directexpertaccess,
  },
  {
    key: "faster",
    label: "Faster Better Decisions",
    icon: fasterbetterdecisions,
  },
  {
    key: "onestop",
    label: "One Stop Solution",
    icon: onestopsolution,
  },
];

// Per-service display metadata that the /api/space/listspace endpoint doesn't
// provide (booking availability, checkout id, display order). Keyed by Title
// rather than the API's numeric Id, since the Id ordering doesn't match the
// intended card layout.
const SERVICE_META = {
  "HARMONY REVIEW": { id: "harmony-review", cta: "GET REVIEW", available: true, order: 0 },
  "HARMONY CONSULTATION": { id: "harmony-consultation", cta: "COMING SOON", available: false, order: 1 },
  "HARMONY REVIEW + ID CONSULT": { id: "harmony-review-id", cta: "GET REVIEW", available: true, order: 2 },
  "HARMONY CONSULTATION + ID CONSULT": { id: "harmony-consultation-id", cta: "COMING SOON", available: false, order: 3 },
};

function MothIcon({ size = 26 }) {
  const h = Math.round(size * 18 / 26);
  return (
    <svg width={size} height={h} viewBox="0 0 26 18" fill="none" opacity="0.5">
      <ellipse cx="8" cy="9" rx="7" ry="4" fill="rgba(200,190,220,0.4)" transform="rotate(-18 8 9)" />
      <ellipse cx="18" cy="9" rx="7" ry="4" fill="rgba(200,190,220,0.4)" transform="rotate(18 18 9)" />
      <line x1="13" y1="4" x2="13" y2="14" stroke="rgba(220,210,235,0.6)" strokeWidth="1" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <img src={check} alt="" width={16} height={16} style={{ flexShrink: 0, marginTop: 2 }} />
  );
}

const BalanceInSpace = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [packageSelectOpen, setPackageSelectOpen] = useState(false);
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [howItWorksOpen, setHowItWorksOpen] = useState(false);
  const [stripeOpen, setStripeOpen] = useState(false);
  const [loginRequiredOpen, setLoginRequiredOpen] = useState(false);
  // pending holds which payment flow to resume once a guardian confirms: "gems" | "stripe"
  const [guardianModal, setGuardianModal] = useState({ show: false, pending: null });
  const [paymentResultModal, setPaymentResultModal] = useState({ open: false, status: "success", message: "" });
  const [services, setServices] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(true);
  const [selectedService, setSelectedService] = useState(null);
  const [submittingPayment, setSubmittingPayment] = useState(false);
  const [fromGetStarted, setFromGetStarted] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("stripe");
  const [insufficientGemsModal, setInsufficientGemsModal] = useState({ show: false, required: 0, current: 0 });
  const [gemConfirmOpen, setGemConfirmOpen] = useState(false);
  const [gemConfirming, setGemConfirming] = useState(false);
  const rootRef = useRef(null);
  const bgLayerRef = useRef(null);
  const userAgeRef = useRef(undefined);
  const submitLockRef = useRef(false);
  const gemConfirmLockRef = useRef(false);

  const fetchUserAge = async () => {
    if (userAgeRef.current !== undefined) return userAgeRef.current;
    try {
      const userID = localStorage.getItem("userID");
      const res = await fetch("https://xianhefairy.com/LotusFairy_API/api/User/GetProfile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UserName: localStorage.getItem("username") || "",
          ID: parseInt(userID || "0", 10),
          LangId: parseInt(localStorage.getItem("languageId") || "2224", 10) || 2224,
          UserToken: "",
          Token: { AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp" },
        }),
      });
      if (!res.ok) { userAgeRef.current = null; return null; }
      const data = await res.json();
      const age = data?.Profiles?.[0]?.Age ?? null;
      userAgeRef.current = age;
      return age;
    } catch {
      userAgeRef.current = null;
      return null;
    }
  };

  useEffect(() => {
    let cancelled = false;

    const fetchServices = async () => {
      try {
        const response = await fetch("https://xianhefairy.com/LotusFairy_API/api/space/listspace");
        if (!response.ok) {
          console.error(`API error: ${response.status} ${response.statusText}`);
          setServicesLoading(false);
          return;
        }
        const data = await response.json();
        if (cancelled) return;
        if (!Array.isArray(data)) {
          console.error("Expected array from API, got:", typeof data);
          setServicesLoading(false);
          return;
        }

        const mapped = data
          .map((item) => {
            const meta = SERVICE_META[(item.Title || "").trim().toUpperCase()] || {};
            return {
              id: meta.id || `space-${item.Id}`,
              apiId: item.Id,
              order: meta.order ?? item.Id,
              title: item.Title,
              subtitle: item.Description,
              imgUrl: item.ImgUrl,
              features: (item.Details || []).map((d) => d.Description),
              price: item.CashAmt,
              gemAmt: item.GemAmt || 0,
              cta: meta.cta || "COMING SOON",
              available: meta.available || false,
            };
          })
          .sort((a, b) => a.order - b.order);

        setServices(mapped);
        setSelectedService((prev) => prev || mapped.find((s) => s.title === "HARMONY REVIEW + ID CONSULT") || mapped.find((s) => s.available) || mapped[0] || null);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        if (!cancelled) setServicesLoading(false);
      }
    };

    fetchServices();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (packageSelectOpen && (!selectedService || !selectedService.available)) {
      const defaultService = services.find((s) => s.title === "HARMONY REVIEW + ID CONSULT");
      if (defaultService) {
        setSelectedService(defaultService);
      }
    }
  }, [packageSelectOpen, services]);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    // Find the actual scroll container (the routed layout's <main> scrolls
    // internally, the window doesn't), so the fixed bg layer below can be
    // translated in sync with it instead of staying glued to the viewport.
    let scrollEl = root.parentElement;
    while (scrollEl && scrollEl !== document.body) {
      const { overflowY } = window.getComputedStyle(scrollEl);
      if (overflowY === "auto" || overflowY === "scroll") break;
      scrollEl = scrollEl.parentElement;
    }
    if (!scrollEl) return;

    const handleScroll = () => {
      if (bgLayerRef.current) {
        bgLayerRef.current.style.transform = `translateY(${-scrollEl.scrollTop}px)`;
      }
    };
    scrollEl.addEventListener("scroll", handleScroll, { passive: true });
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (packageSelectOpen || reviewModalOpen || howItWorksOpen || loginRequiredOpen || guardianModal.show || paymentResultModal.open || insufficientGemsModal.show || gemConfirmOpen) {
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prevOverflow;
      };
    }
  }, [packageSelectOpen, reviewModalOpen, howItWorksOpen, loginRequiredOpen, guardianModal.show, paymentResultModal.open, insufficientGemsModal.show, gemConfirmOpen]);

  const fetchTotalCoins = async (customerID) => {
    try {
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${customerID}`);
      if (!response.ok) throw new Error("Failed to fetch coins");
      const data = await response.json();
      const coins = Array.isArray(data) && data.length > 0 ? data[0].COINS : 0;
      localStorage.setItem("coins", coins);
      return coins;
    } catch (error) {
      console.error("Error fetching coin balance:", error);
      return 0;
    }
  };

  const postPurchaseCoin = async (customerID, amount, pid = 0, payMode = 1) => {
    const payload = {
      prefix: "PH",
      Items: [
        {
          CustomerId: Number(customerID) || 0,
          pid,
          Quantity: 1,
          Amount: amount,
        },
      ],
      PAY_MODE: payMode
    };

    const response = await fetch("https://xianhefairy.com/LotusFairy_API/api/member/PostPurchaseCoin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    // for test
    // const response = await fetch("https://xianhefairy.com/LotusFairy_API/api/member/PostPurchaseCoin", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(payload),
    // });

    if (!response.ok) {
      throw new Error(`PostPurchaseCoin failed with status ${response.status}`);
    }

    const data = await response.json();
    console.log("Purchase recorded:", data);
    return data;
  };

  const handlePaymentSuccess = async () => {
    setStripeOpen(false);
    const userID = localStorage.getItem("userID");

    try {
      await postPurchaseCoin(userID, selectedService?.price, selectedService?.apiId);
      setPaymentResultModal({
        open: true,
        status: "success",
        message: "Your payment was successful and your purchase has been recorded. An email confirmation has been sent to the masters. Thank you for your order!",
      });
    } catch (error) {
      console.error("PostPurchaseCoin error after successful payment:", error);
      setPaymentResultModal({
        open: true,
        status: "warning",
        message: "Your payment went through, but we weren't able to save your purchase record. Please contact support so we can complete your order.",
      });
    }
  };

  // Closing the success modal reloads the page so gem/coin balances shown
  // elsewhere (e.g. Tryoutpage's header count) pick up the new total.
  const closePaymentResultModal = () => {
    const wasSuccess = paymentResultModal.status === "success";
    setPaymentResultModal({ open: false, status: "success", message: "" });
    if (wasSuccess) {
      window.location.reload();
    }
  };

  // Runs the login/age/balance checks for a gem purchase, then hands off to
  // the confirm modal — actual deduction only happens from confirmGemPayment.
  const handleGemPayment = async () => {
    const userID = localStorage.getItem("userID");
    if (!userID) {
      setLoginRequiredOpen(true);
      return;
    }

    const age = await fetchUserAge();
    if (age !== null && age < 18) {
      setGuardianModal({ show: true, pending: "gems" });
      return;
    }

    await proceedGemPayment();
  };

  const proceedGemPayment = async () => {
    const userID = localStorage.getItem("userID");
    const requiredGems = getGemAmount(selectedService);
    const coins = await fetchTotalCoins(userID);
    if (coins < requiredGems) {
      setInsufficientGemsModal({ show: true, required: requiredGems, current: coins });
      return;
    }

    setGemConfirmOpen(true);
  };

  const confirmGemPayment = async () => {
    if (gemConfirmLockRef.current) return;
    gemConfirmLockRef.current = true;
    setGemConfirming(true);

    const userID = localStorage.getItem("userID");
    const requiredGems = getGemAmount(selectedService);

    try {
      await postPurchaseCoin(userID, requiredGems, selectedService?.apiId, 0);
      setGemConfirmOpen(false);
      setHowItWorksOpen(false);
      setPaymentResultModal({
        open: true,
        status: "success",
        message: "Your payment was successful and your purchase has been recorded. An email confirmation has been sent to the masters. Thank you for your order!",
      });
    } catch (error) {
      console.error("PostPurchaseCoin error for gem payment:", error);
      setGemConfirmOpen(false);
      setPaymentResultModal({
        open: true,
        status: "warning",
        message: "We weren't able to process your gem payment. Please try again or contact support.",
      });
    } finally {
      gemConfirmLockRef.current = false;
      setGemConfirming(false);
    }
  };

  // submitLockRef guards synchronously against a double-click landing before
  // the disabled={submittingPayment} re-render takes effect.
  const handleSubmitPaymentClick = async () => {
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    setSubmittingPayment(true);

    try {
      if (paymentMethod === "gems") {
        await handleGemPayment();
        return;
      }

      const userID = localStorage.getItem("userID");
      if (!userID) {
        setLoginRequiredOpen(true);
        return;
      }

      const age = await fetchUserAge();
      if (age !== null && age < 18) {
        setGuardianModal({ show: true, pending: "stripe" });
        return;
      }

      proceedStripePayment();
    } finally {
      submitLockRef.current = false;
      setSubmittingPayment(false);
    }
  };

  const proceedStripePayment = () => {
    setHowItWorksOpen(false);
    setStripeOpen(true);
  };

  // Resumes whichever flow the age check interrupted, once a guardian confirms.
  const handleGuardianProceed = () => {
    const pending = guardianModal.pending;
    setGuardianModal({ show: false, pending: null });
    if (pending === "gems") {
      proceedGemPayment();
    } else if (pending === "stripe") {
      proceedStripePayment();
    }
  };

  return (
    <>
      {/* Fixed + scroll-synced (see effect above) so it renders behind the
          transparent site header at the top, then scrolls away with the page
          instead of staying glued to the viewport. */}
      <div
        ref={bgLayerRef}
        style={{
          position: "fixed",
          top: -70,
          left: 0,
          width: "100%",
          height: "101.3vw",
          backgroundImage: `url(${bg})`,
          backgroundSize: "100% auto",
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          pointerEvents: "none",
          zIndex: 1,
          WebkitMaskImage: "linear-gradient(to bottom, black 95%, transparent 100%)",
          maskImage: "linear-gradient(to bottom, black 95%, transparent 100%)",
        }}
      />
      <div ref={rootRef} style={{
      width: "100%",
      color: "#fff",
      fontFamily: "'DMSans', sans-serif",
      paddingBottom: 60,
      position: "relative",
      zIndex: 2,
      overflow: "hidden",
    }}>
      <style>{`
        .bis-stars {
          position: absolute;
          inset: 0;
          pointer-events: none;
          background-image:
            radial-gradient(1px 1px at 10% 15%, rgba(255,255,255,0.5), transparent),
            radial-gradient(1px 1px at 30% 40%, rgba(255,255,255,0.4), transparent),
            radial-gradient(1px 1px at 60% 10%, rgba(255,255,255,0.5), transparent),
            radial-gradient(1px 1px at 80% 30%, rgba(255,255,255,0.35), transparent),
            radial-gradient(1px 1px at 45% 70%, rgba(255,255,255,0.3), transparent),
            radial-gradient(1px 1px at 90% 65%, rgba(255,255,255,0.4), transparent),
            radial-gradient(1px 1px at 15% 85%, rgba(255,255,255,0.3), transparent);
          background-size: 100% 100%;
          opacity: 0.8;
        }
        .bis-cards-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 28px;
        }
        .bis-why-row {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 24px;
        }
        .bis-features {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 8px 16px;
        }
        .bis-receive-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 24px;
        }
        .bis-steps-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
        }
        .bis-step-item {
          flex: 0 0 140px;
        }
        .bis-step-sep {
          flex: 1 1 50px;
          min-width: 40px;
          position: relative;
          height: 22px;
        }
        .bis-step-sep::before {
          content: "";
          position: absolute;
          top: 50%;
          left: -45px;
          right: -45px;
          border-top: 2px dashed rgba(223,189,105,0.6);
          z-index: 0;
        }
        .bis-step-sep .bis-chevron {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #150f28;
          color: ${gold};
          font-size: 20px;
          font-weight: 700;
          letter-spacing: -1px;
        }
        .bis-info-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 24px;
        }
        @media (max-width: 900px) {
          .bis-cards-grid { grid-template-columns: 1fr; }
          .bis-why-row { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .bis-features { grid-template-columns: 1fr; }
          .bis-receive-grid { grid-template-columns: 1fr; }
          .bis-steps-row { flex-direction: column; align-items: center; }
          .bis-step-sep { display: none; }
          .bis-info-grid { grid-template-columns: 1fr; }
        }
        .bis-card:hover {
          border-color: rgba(223,189,105,0.7) !important;
          box-shadow: 0 0 24px rgba(223,189,105,0.15) !important;
        }
        .bis-cta-btn:hover { background: #f0d38a !important; }
        .bis-outline-btn:disabled { opacity: 0.55; cursor: not-allowed; }
      `}</style>
      <div className="bis-stars" />

      {/* HERO */}
      <section style={{ position: "relative", textAlign: "center", padding: "90px 20px 50px", maxWidth: 900, margin: "0 auto" }}>
        <h1 style={{
          fontFamily: "'PlayfairDisplay', serif",
          color: "#DDAE7A",
          fontSize: "clamp(1.8rem, 4vw, 2.6rem)",
          letterSpacing: 2,
          margin: 0,
          fontWeight: 700,
        }}>
          FENG SHUI INTERIOR DESIGN
        </h1>
        <p style={{
          color: goldSoft,
          fontStyle: "italic",
          fontSize: "1.05rem",
          margin: "12px 0 0",
        }}>
          Balance Your Space, Transform Your Life
        </p>
        <p style={{
          color: "rgba(255,255,255,0.8)",
          fontSize: "0.95rem",
          lineHeight: 1.6,
          maxWidth: 640,
          margin: "18px auto 0",
        }}>
          Professional feng shui consultation combined with interior design solutions to create harmony, prosperity and wellbeing in your home.
        </p>
      </section>

      {/* OUR SERVICES */}
      <section style={{ position: "relative", maxWidth: 1100, margin: "0 auto", padding: "10px 20px 0" }}>
        <h2 style={{
          textAlign: "center",
          fontFamily: "'PlayfairDisplay', serif",
          color: gold,
          fontSize: "clamp(1.4rem, 3vw, 1.8rem)",
          marginBottom: 36,
          fontWeight: 700,
        }}>
          OUR SERVICES
        </h2>

        <div className="bis-cards-grid">
          {servicesLoading && (
            <p style={{ gridColumn: "1 / -1", textAlign: "center", color: "rgba(255,255,255,0.7)" }}>
              Loading services…
            </p>
          )}
          {!servicesLoading && services.length === 0 && (
            <p style={{ gridColumn: "1 / -1", textAlign: "center", color: "rgba(255,255,255,0.7)" }}>
              Unable to load services right now. Please try again later.
            </p>
          )}
          {services.map((svc) => {
            // Let the box follow each image's own aspect ratio instead of the
            // hardcoded SERVICE_META ratio, so a dynamically-loaded image is
            // never cropped to fit a guessed shape — the full image always shows.
            const mockup = (
              <div style={{
                borderRadius: 10,
                // border: `1px solid ${gold}`,
                overflow: "hidden",
              }}>
                <img
                  src={svc.imgUrl}
                  alt={svc.title}
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </div>
            );

            return (
              <div
                key={svc.id}
                className="bis-card"
                style={{
                  border: "1px solid rgba(223,189,105,0.4)",
                  borderRadius: 14,
                  background: "#0A031E",
                  padding: 22,
                  display: "flex",
                  flexDirection: "column",
                  gap: 14,
                  transition: "border-color .25s, box-shadow .25s",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <h3 style={{
                    fontFamily: "'PlayfairDisplay', serif",
                    color: gold,
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    margin: 0,
                  }}>
                    {svc.title}
                  </h3>
                  <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "1.125rem", margin: "6px 6px 0" }}>
                    {svc.subtitle}
                  </p>
                </div>

                {mockup}

                <ul className="bis-features" style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  {svc.features.map((f, i) => (
                    <li key={i} style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 12.5, color: "rgba(255,255,255,0.85)", lineHeight: 1.35 }}>
                      <CheckIcon />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <div style={{
                  marginTop: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 10,
                  borderTop: "1px solid rgba(42,32,20,1.0)",
                }}>
                  <div>
                    <span style={{ color: gold, fontSize: 20  }}>USD </span>
                    <span style={{ color: gold, fontSize: 40 , fontWeight: 700 }}>{svc.price}</span>
                  </div>
                  <button
                    className={svc.available ? "bis-cta-btn" : "bis-outline-btn"}
                    disabled={!svc.available}
                    onClick={() => {
                      if (!svc.available) return;
                      setSelectedService(svc);
                      setFromGetStarted(false);
                      setReviewModalOpen(true);
                    }}
                    style={{
                      padding: "10px 20px",
                      minWidth: 130,
                      borderRadius: 10,
                      fontSize: 12,
                      fontWeight: 700,
                      letterSpacing: 0.5,
                      textAlign: "center",
                      cursor: svc.available ? "pointer" : "not-allowed",
                      border: svc.available ? "none" : "1px solid rgba(255,255,255,0.3)",
                      background: svc.available ? gold : "transparent",
                      color: svc.available ? "#000" : "rgba(255,255,255,0.5)",
                      transition: "background .2s",
                    }}
                  >
                    {svc.cta}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section style={{ position: "relative", maxWidth: 1100, margin: "60px auto 0", padding: "36px 20px" }}>
        <div style={{
          border: "1px solid rgba(223,189,105,0.3)",
          borderRadius: 16,
          background: "#0A031E",
          padding: "34px 26px",
          position: "relative",
          overflow: "hidden",
        }}>
          <img src={flair} alt="" style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "left center",
            zIndex: 0,
            opacity: 1.0,
          }} />
          <h2 style={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            fontFamily: "'PlayfairDisplay', serif",
            color: gold,
            fontSize: "1.4rem",
            margin: "0 0 30px",
          }}>
            WHY CHOOSE US
          </h2>
          <div className="bis-why-row" style={{ position: "relative", zIndex: 1 }}>
            {WHY_CHOOSE_US.map((item) => (
              <div key={item.key} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
                <div style={{
                  width: 54, height: 54,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <img src={item.icon} alt={item.label} width={44} height={44} />
                </div>
                <span style={{ fontSize: 13, color: "rgba(255,255,255,0.85)", fontWeight: 600 }}>{item.label}</span>
              </div>
            ))}
          </div>

          {/* Dividing line */}
          <div style={{ position: "relative", zIndex: 1, height: 1, background: "#2A2014", margin: "30px 10px" }} />

          {/* CTA */}
          <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
            <h2 style={{
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "clamp(1.3rem, 3vw, 1.7rem)",
              letterSpacing: 1.5,
              margin: "0 0 14px",
            }}>
              TRANSFORM YOUR HOME NOW
            </h2>
            <p style={{ color: "rgba(255,255,255,0.75)", fontSize: 14, margin: "14px 0 26px", lineHeight: 1.5 }}>
              Book your Feng Shui interior consultation today and start your journey toward a more harmonious home.
            </p>
            <button
              className="bis-cta-btn"
              onClick={() => {
                setFromGetStarted(true);
                setPackageSelectOpen(true);
              }}
              style={{
                padding: "14px 40px",
                borderRadius: 500,
                border: "none",
                background: gold,
                color: "#000",
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: 0.5,
                cursor: "pointer",
                transition: "background .2s",
              }}
            >
              GET STARTED
            </button>
          </div>
        </div>
      </section>

      {/* PACKAGE SELECTION modal */}
      {packageSelectOpen && createPortal(
        <div
          onClick={() => setPackageSelectOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "#171326",
              border: "1px solid rgba(201,168,75,0.4)",
              borderRadius: 20,
              padding: "36px 40px",
              maxWidth: 900,
              width: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <button
              onClick={() => setPackageSelectOpen(false)}
              aria-label="Close"
              style={{
                position: "absolute", top: 16, right: 18, background: "transparent",
                border: "none", color: gold, fontSize: 20, cursor: "pointer", lineHeight: 1,
              }}
            >
              ×
            </button>

            <h2 style={{
              textAlign: "center",
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "2rem",
              fontWeight: 700,
              margin: "0 0 30px",
            }}>
              SELECT YOUR PACKAGE
            </h2>

            <div className="bis-cards-grid" style={{ marginBottom: 30 }}>
              {services.filter((s) => s.available).map((svc) => (
                <div
                  key={svc.id}
                  className="bis-card"
                  onClick={() => {
                    setSelectedService(svc);
                    setPackageSelectOpen(false);
                    setReviewModalOpen(true);
                  }}
                  style={{
                    border: selectedService?.id === svc.id ? `2px solid ${gold}` : "1px solid rgba(223,189,105,0.4)",
                    borderRadius: 14,
                    background: selectedService?.id === svc.id ? "rgba(223,189,105,0.1)" : "#0A031E",
                    padding: 22,
                    display: "flex",
                    flexDirection: "column",
                    gap: 14,
                    transition: "border-color .25s, box-shadow .25s, background .25s",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <h3 style={{
                      fontFamily: "'PlayfairDisplay', serif",
                      color: gold,
                      fontSize: "1.5rem",
                      fontWeight: 600,
                      margin: 0,
                    }}>
                      {svc.title}
                    </h3>
                    <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "1.125rem", margin: "6px 6px 0" }}>
                      {svc.subtitle}
                    </p>
                  </div>

                  <ul className="bis-features" style={{ listStyle: "none", margin: 0, padding: 0 }}>
                    {svc.features.map((f, i) => (
                      <li key={i} style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 12.5, color: "rgba(255,255,255,0.85)", lineHeight: 1.35 }}>
                        <CheckIcon />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>

                  <div style={{
                    marginTop: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingTop: 10,
                    borderTop: "1px solid rgba(42,32,20,1.0)",
                  }}>
                    <div>
                      <span style={{ color: gold, fontSize: 20 }}>USD </span>
                      <span style={{ color: gold, fontSize: 40, fontWeight: 700 }}>{svc.price}</span>
                    </div>
                    <div style={{
                      padding: "10px 20px",
                      borderRadius: 10,
                      fontSize: 12,
                      fontWeight: 700,
                      letterSpacing: 0.5,
                      textAlign: "center",
                      border: "1px solid rgba(223,189,105,0.5)",
                      background: selectedService?.id === svc.id ? gold : "transparent",
                      color: selectedService?.id === svc.id ? "#000" : gold,
                      transition: "background .2s, color .2s",
                    }}>
                      {selectedService?.id === svc.id ? "SELECTED" : "SELECT"}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ textAlign: "center" }}>
              <button
                className="bis-cta-btn"
                onClick={() => {
                  setPackageSelectOpen(false);
                  setReviewModalOpen(true);
                }}
                style={{
                  padding: "13px 44px",
                  borderRadius: 30,
                  border: "none",
                  background: gold,
                  color: "#000",
                  fontSize: 14,
                  fontWeight: 700,
                  letterSpacing: 0.5,
                  cursor: "pointer",
                  transition: "background .2s",
                }}
              >
                CONTINUE
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* YOU WILL RECEIVE modal */}
      {reviewModalOpen && createPortal(
        <div
          onClick={() => setReviewModalOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "#171326",
              border: "1px solid rgba(201,168,75,0.4)",
              borderRadius: 20,
              padding: "36px 40px",
              maxWidth: 920,
              width: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <button
              onClick={() => setReviewModalOpen(false)}
              aria-label="Close"
              style={{
                position: "absolute", top: 16, right: 18, background: "transparent",
                border: "none", color: gold, fontSize: 20, cursor: "pointer", lineHeight: 1,
              }}
            >
              ×
            </button>

            <h2 style={{
              textAlign: "center",
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "2.5rem",
              fontWeight: 700,
              margin: "0 0 30px",
            }}>
              YOU WILL RECEIVE
            </h2>

            <div className="bis-receive-grid">
              {RECEIVE_STEPS.map((step, i) => {
                let mockup;
                if (step.mockup === "compass") {
                  mockup = (
                    <img src={compassanalysis} alt="Compass Analysis" style={{ width: "100%", borderRadius: 10 }} />
                  );
                } else if (step.mockup === "recommendations") {
                  mockup = (
                    <img src={fengshuirecommendations} alt="Your Space Recommendations" style={{ width: "100%", borderRadius: 10 }} />
                  );
                } else {
                  mockup = (
                    <img src={enhancementsuggestions} alt="Enhancement Suggestions" style={{ width: "100%", borderRadius: 10 }} />
                  );
                }

                return (
                  <div key={step.key}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                      <span style={{
                        width: 22, height: 22, borderRadius: "50%", background: purple,
                        color: "#fff", fontSize: 12, fontWeight: 700,
                        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                      }}>
                        {i + 1}
                      </span>
                      <span style={{
                        color: goldSoft, fontSize: 12,
                        letterSpacing: 0.8, fontWeight: 700,
                      }}>
                        {step.title}
                      </span>
                    </div>
                    {mockup}
                  </div>
                );
              })}
            </div>

            <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", gap: 4, margin: "18px 0 24px" }}>
              <span style={{ position: "absolute", left: 0, right: 0, top: 30, height: 1, background: "#2A2014", zIndex: 0 }} />
              <img src={butterfly} alt="" style={{ width: 80, height: 80, opacity: 0.7, transform: "rotate(15deg)", position: "relative", zIndex: 1 }} />
              <p style={{ textAlign: "center", color: "rgba(255,255,255,0.6)", fontStyle: "italic", fontSize: 14, margin: "30px 0 0", position: "relative", zIndex: 1 }}>
                Reports will be provided in PDF format for your reference.
              </p>
              <img src={butterfly} alt="" style={{ width: 80, height: 80, opacity: 0.7, transform: "rotate(-15deg) scaleX(-1)", position: "relative", zIndex: 1 }} />
            </div>

            <div style={{ textAlign: "center", display: "flex", gap: 16, alignItems: "center", justifyContent: "center" }}>
              {fromGetStarted && (
                <button
                  onClick={() => {
                    setReviewModalOpen(false);
                    setPackageSelectOpen(true);
                  }}
                  style={{
                    padding: "13px 44px",
                    borderRadius: 30,
                    border: "1px solid rgba(223,189,105,0.5)",
                    background: "transparent",
                    color: gold,
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    cursor: "pointer",
                    transition: "background .2s, color .2s",
                  }}
                >
                  BACK
                </button>
              )}
              <button
                className="bis-cta-btn"
                onClick={() => {
                  setReviewModalOpen(false);
                  setHowItWorksOpen(true);
                }}
                style={{
                  padding: "13px 44px",
                  borderRadius: 30,
                  border: "none",
                  background: gold,
                  color: "#000",
                  fontSize: 14,
                  fontWeight: 700,
                  letterSpacing: 0.5,
                  cursor: "pointer",
                  transition: "background .2s",
                }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* HOW IT WORKS modal */}
      {howItWorksOpen && createPortal(
        <div
          onClick={() => setHowItWorksOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "linear-gradient(160deg, #1b1130 0%, #0f0b1a 100%)",
              border: "1px solid rgba(223,189,105,0.35)",
              borderRadius: 20,
              padding: "36px 40px",
              maxWidth: 1060,
              width: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <button
              onClick={() => setHowItWorksOpen(false)}
              aria-label="Close"
              style={{
                position: "absolute", top: 16, right: 18, background: "transparent",
                border: "none", color: gold, fontSize: 20, cursor: "pointer", lineHeight: 1,
              }}
            >
              ×
            </button>

            <h2 style={{
              textAlign: "center",
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "1.5rem",
              margin: "0 0 30px",
              position: "relative",
            }}>
              HOW IT WORKS
            </h2>

            <div style={{ position: "relative", display: "flex", alignItems: "flex-start" }}>
              <img src={butterflywithtext} alt="" width={110} height={110} style={{ position: "absolute", left: -34, top: -40, pointerEvents: "none" }} />
              <div className="bis-steps-row" style={{ flex: 1, minWidth: 0 }}>
                {HOW_IT_WORKS_STEPS.map((step, i) => {
                  const iconImage = {
                    upload: step1,
                    review: step2,
                    report: step3,
                    consultation: step4,
                  }[step.icon];
                  const icon = <img src={iconImage} alt="" width={40} height={40} />;

                  return (
                    <React.Fragment key={step.key}>
                      <div className="bis-step-item" style={{
                        textAlign: "center",
                        opacity: step.active ? 1 : 0.65,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}>
                        <div style={{
                          width: 40, height: 40, margin: "0 auto 10px",
                          display: "flex", alignItems: "center", justifyContent: "center",
                        }}>
                          {icon}
                        </div>
                        <div style={{ width: 180 }}>
                          <div style={{ color: gold, fontSize: 18, fontWeight: 700, letterSpacing: 1, marginBottom: 4, fontFamily: "'PlayfairDisplay', serif" }}>{step.label}</div>
                          <div style={{ color: "#fff", fontSize: 14, fontWeight: 700, marginBottom: 6 }}>{step.title}</div>
                          <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 14}}>{step.desc}</div>
                        </div>
                      </div>
                      {i < HOW_IT_WORKS_STEPS.length - 1 && (
                        <div className="bis-step-sep" style={{ alignSelf: "flex-start", marginTop: 9 }}>
                          <span className="bis-chevron">»</span>
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>

            <div style={{ height: 1, background: "rgba(223,189,105,0.2)", margin: "34px 0" }} />

            <h2 style={{
              textAlign: "center",
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "1.5rem",
              margin: "0 0 28px",
            }}>
              INFORMATION REQUIRED
            </h2>

            <div className="bis-info-grid">
              {INFO_REQUIRED.map((col) => {
                const iconImage = {
                  camera: homeinformation,
                  magnifier: familyinformation,
                  gear: consultationpreference,
                }[col.icon];
                const icon = <img src={iconImage} alt="" width={44} height={44} />;

                return (
                  <div key={col.key} style={{ textAlign: "center" }}>
                    <div style={{
                      width: 44, height: 44,
                      display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px",
                    }}>
                      {icon}
                    </div>
                    <div style={{ color: "#fff", fontSize: 13, fontWeight: 700, letterSpacing: 0.5, marginBottom: 12 }}>{col.title}</div>
                    <ul style={{ listStyle: "none", margin: 0, padding: 0, textAlign: "left", display: "inline-block" }}>
                      {col.items.map((item) => (
                        <li key={item} style={{ display: "flex", alignItems: "flex-start", gap: 7, fontSize: 12.5, color: "rgba(255,255,255,0.8)", marginBottom: 6 }}>
                          <span style={{ color: gold, flexShrink: 0 }}>✓</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>

            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 24,
              marginTop: 30,
              color: gold,
              fontSize: 13,
            }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: submittingPayment ? "not-allowed" : "pointer", opacity: submittingPayment ? 0.6 : 1 }}>
                <input
                  type="radio"
                  value="stripe"
                  checked={paymentMethod === "stripe"}
                  onChange={() => setPaymentMethod("stripe")}
                  disabled={submittingPayment}
                />
                PAY WITH CARD
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: submittingPayment ? "not-allowed" : "pointer", opacity: submittingPayment ? 0.6 : 1 }}>
                <input
                  type="radio"
                  value="gems"
                  checked={paymentMethod === "gems"}
                  onChange={() => setPaymentMethod("gems")}
                  disabled={submittingPayment}
                />
                PAY WITH GEMS ({getGemAmount(selectedService)} Gems)
              </label>
            </div>

            <div style={{ textAlign: "center", marginTop: 18, display: "flex", gap: 16, alignItems: "center", justifyContent: "center" }}>
              {fromGetStarted && (
                <button
                  onClick={() => {
                    setHowItWorksOpen(false);
                    setReviewModalOpen(true);
                  }}
                  style={{
                    padding: "13px 44px",
                    borderRadius: 30,
                    border: "1px solid rgba(223,189,105,0.5)",
                    background: "transparent",
                    color: gold,
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    cursor: "pointer",
                    transition: "background .2s, color .2s",
                  }}
                >
                  BACK
                </button>
              )}
              <button
                className="bis-cta-btn"
                disabled={submittingPayment}
                onClick={handleSubmitPaymentClick}
                style={{
                  padding: "13px 44px",
                  borderRadius: 30,
                  border: "none",
                  background: gold,
                  color: "#000",
                  fontSize: 14,
                  fontWeight: 700,
                  letterSpacing: 0.5,
                  cursor: submittingPayment ? "not-allowed" : "pointer",
                  transition: "background .2s",
                  opacity: submittingPayment ? 0.7 : 1,
                }}
              >
                {submittingPayment ? "PROCESSING..." : "SUBMIT PAYMENT"}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <StripePayment
        id={selectedService?.id}
        amount={selectedService?.price}
        currency="usd"
        isOpen={stripeOpen}
        onClose={() => setStripeOpen(false)}
        onPaymentSuccess={handlePaymentSuccess}
      />

      {/* PAYMENT RESULT modal */}
      {paymentResultModal.open && createPortal(
        <div
          onClick={closePaymentResultModal}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "#171326",
              border: `1px solid ${paymentResultModal.status === "success" ? "rgba(201,168,75,0.4)" : "rgba(220,120,70,0.5)"}`,
              borderRadius: 20,
              padding: "40px 36px",
              maxWidth: 440,
              width: "100%",
              textAlign: "center",
            }}
          >
            <button
              onClick={closePaymentResultModal}
              aria-label="Close"
              style={{
                position: "absolute", top: 16, right: 18, background: "transparent",
                border: "none", color: gold, fontSize: 20, cursor: "pointer", lineHeight: 1,
              }}
            >
              ×
            </button>

            <div style={{
              width: 56, height: 56, borderRadius: "50%", margin: "0 auto 18px",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: paymentResultModal.status === "success" ? "rgba(201,168,75,0.15)" : "rgba(220,120,70,0.15)",
              color: paymentResultModal.status === "success" ? gold : "#e08a5c",
              fontSize: 28,
            }}>
              {paymentResultModal.status === "success" ? "✓" : "!"}
            </div>

            <h2 style={{
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "1.4rem",
              fontWeight: 700,
              margin: "0 0 12px",
            }}>
              {paymentResultModal.status === "success" ? "Payment Successful" : "Payment Received"}
            </h2>

            <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 14, lineHeight: 1.6, margin: "0 0 26px" }}>
              {paymentResultModal.message}
            </p>

            <button
              className="bis-cta-btn"
              onClick={closePaymentResultModal}
              style={{
                padding: "12px 40px",
                borderRadius: 30,
                border: "none",
                background: gold,
                color: "#000",
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: 0.5,
                cursor: "pointer",
                transition: "background .2s",
              }}
            >
              CLOSE
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* LOGIN REQUIRED modal */}
      {loginRequiredOpen && createPortal(
        <div
          onClick={() => setLoginRequiredOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "#171326",
              border: "1px solid rgba(201,168,75,0.4)",
              borderRadius: 20,
              padding: "40px 36px",
              maxWidth: 440,
              width: "100%",
              textAlign: "center",
            }}
          >
            <button
              onClick={() => setLoginRequiredOpen(false)}
              aria-label="Close"
              style={{
                position: "absolute", top: 16, right: 18, background: "transparent",
                border: "none", color: gold, fontSize: 20, cursor: "pointer", lineHeight: 1,
              }}
            >
              ×
            </button>

            <div style={{
              width: 56, height: 56, borderRadius: "50%", margin: "0 auto 18px",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "rgba(201,168,75,0.15)",
              color: gold,
              fontSize: 28,
            }}>
              ⚠
            </div>

            <h2 style={{
              fontFamily: "'PlayfairDisplay', serif",
              color: gold,
              fontSize: "1.4rem",
              fontWeight: 700,
              margin: "0 0 12px",
            }}>
              Login Required
            </h2>

            <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 14, lineHeight: 1.6, margin: "0 0 26px" }}>
              You need to be logged in to make a purchase. Please log in to your account to proceed with payment.
            </p>

            <button
              className="bis-cta-btn"
              onClick={() => setLoginRequiredOpen(false)}
              style={{
                padding: "12px 40px",
                borderRadius: 30,
                border: "none",
                background: gold,
                color: "#000",
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: 0.5,
                cursor: "pointer",
                transition: "background .2s",
              }}
            >
              RETURN
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* GUARDIAN CONFIRMATION modal (for users under 18 attempting payment) */}
      {guardianModal.show && createPortal(
        <div
          onClick={() => setGuardianModal({ show: false, pending: null })}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            style={{
              background: "#1a1a1a",
              borderRadius: 12,
              padding: "28px 24px",
              width: "min(460px, 92vw)",
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
              border: "1px solid rgba(223,189,105,0.25)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ color: gold, margin: "0 0 16px", fontSize: "1.2rem" }}>
              {t("cart.guardianConfirmationRequired")}
            </h3>
            <p style={{ color: "#fff2d2", marginBottom: 28, lineHeight: 1.6 }}>
              {t("cart.guardianMessage")}
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                onClick={handleGuardianProceed}
                style={{
                  background: gold,
                  color: "#151517",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 22px",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: "0.95rem",
                }}
              >
                {t("cart.yesProceed")}
              </button>
              <button
                onClick={() => setGuardianModal({ show: false, pending: null })}
                style={{
                  background: "transparent",
                  color: gold,
                  border: `1px solid ${gold}66`,
                  borderRadius: 8,
                  padding: "10px 22px",
                  cursor: "pointer",
                  fontSize: "0.95rem",
                }}
              >
                {t("cart.noCancel")}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* INSUFFICIENT GEMS modal */}
      {insufficientGemsModal.show && createPortal(
        <div
          onClick={() => setInsufficientGemsModal({ show: false, required: 0, current: 0 })}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            style={{
              background: "#1a1a1a",
              borderRadius: 12,
              padding: "28px 24px",
              width: "min(420px, 92vw)",
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
              border: "1px solid rgba(223,189,105,0.25)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ color: gold, margin: "0 0 16px", fontSize: "1.2rem" }}>Insufficient Gems</h3>
            <p style={{ color: "#fff2d2", marginBottom: 12, lineHeight: 1.6 }}>
              You don't have enough Gems to complete this purchase.
            </p>
            <p style={{ color: "rgba(255,255,255,0.75)", marginBottom: 24, fontSize: 14 }}>
              Required: <strong style={{ color: gold }}>{insufficientGemsModal.required} Gems</strong><br />
              You have: <strong style={{ color: gold }}>{insufficientGemsModal.current} Gems</strong>
            </p>
            <button
              onClick={() => setInsufficientGemsModal({ show: false, required: 0, current: 0 })}
              style={{
                background: gold,
                color: "#151517",
                border: "none",
                borderRadius: 8,
                padding: "10px 28px",
                fontWeight: 700,
                cursor: "pointer",
                fontSize: "0.95rem",
              }}
            >
              OK
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* GEM PAYMENT CONFIRMATION modal */}
      {gemConfirmOpen && createPortal(
        <div
          onClick={() => { if (!gemConfirming) setGemConfirmOpen(false); }}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 30000, padding: 20,
          }}
        >
          <div
            style={{
              background: "#1a1a1a",
              borderRadius: 12,
              padding: "28px 24px",
              width: "min(420px, 92vw)",
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
              border: "1px solid rgba(223,189,105,0.25)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ color: gold, margin: "0 0 16px", fontSize: "1.2rem" }}>Confirm Gem Payment</h3>
            <p style={{ color: "#fff2d2", marginBottom: 24, lineHeight: 1.6 }}>
              Are you sure you want to proceed? <strong style={{ color: gold }}>{getGemAmount(selectedService)} Gems</strong> will be deducted from your balance for <strong>{selectedService?.title}</strong>.
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                onClick={() => setGemConfirmOpen(false)}
                disabled={gemConfirming}
                style={{
                  background: "transparent",
                  color: gold,
                  border: "1px solid rgba(223,189,105,0.5)",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 700,
                  cursor: gemConfirming ? "not-allowed" : "pointer",
                  fontSize: "0.95rem",
                  opacity: gemConfirming ? 0.6 : 1,
                }}
              >
                CANCEL
              </button>
              <button
                onClick={confirmGemPayment}
                disabled={gemConfirming}
                style={{
                  background: gold,
                  color: "#151517",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 700,
                  cursor: gemConfirming ? "not-allowed" : "pointer",
                  fontSize: "0.95rem",
                  opacity: gemConfirming ? 0.7 : 1,
                }}
              >
                {gemConfirming ? "PROCESSING..." : "YES, PROCEED"}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
      </div>
    </>
  );
};

export default BalanceInSpace;
